<template>
  <div class="home_index">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in imgList" :key="'swiper' + index">
          <img class="swiper-slide__img" :src="item" alt />
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-button-prev" style="top:60%;" slot="button-prev"></div>
      <div class="swiper-button-next" style="top:60%;" slot="button-next"></div>
    </swiper>
    <div>
      <div class="wid quick_link">
        <div class="img img1">
          <router-link :to="{path: '/funeral'}"></router-link>
          殡仪馆
        </div>
        <div class="img img2">
          <router-link :to="{path: '/cemetery'}"></router-link>
          陵园墓地
        </div>
        <div class="img img3">
          <router-link :to="{path: '/appoint'}"></router-link>
          预约扫墓
        </div>
        <div class="img img4"><router-link :to="{path: 'article/article', query: { id:426176045379653, aid:2033 } }"></router-link>平台简介</div>
      </div>
    </div>
    <div class="wid section1">
      <div class="news">
        <div class="bigTitle">行业新闻</div>
        <ul class="newsUl" v-show="num==1">
          <li v-for="item in hyNews" :key="item.id" class="li">
            <router-link :to="{path:'article/article', query: {id:'426173197115461',aid:item.id} }"></router-link>
            <img v-if="item.imgUrl != '' " :src="apiUrl + item.imgUrl" class="img" />
            <img v-else src="/imgs/rxlogo.jpg" class="img" />
            <div class="num">
              <div class="h1">{{truncate(item.title,22)}}</div>
              <div class="p">{{truncate(item.headTitle,46)}}</div>
            </div>
          </li>
        </ul>
      </div>
            
    </div>

    <div class="widbg">
      <div class="wid section1 wid-flex">
        <div class="wid_flex">
          <div class="title">
            政策法规
            <router-link :to="newUrl" class="more">更多>></router-link>
          </div>
          <ul class="ls" v-show="num==1">
            <li v-for="item in zcNews" :key="item.id" class="li">
              <router-link :to="{path:'article/article', query: {id:'426173197115461',aid:item.id} }">{{truncate(item.title,20)}}<span>{{item.publicTime}}</span></router-link>
            </li>
          </ul>
        </div>
        <div class="wid_flex">
          <div class="title">
            殡葬文化
            <router-link :to="newUrl" class="more">更多>></router-link>
          </div>
          <ul class="ls" v-show="num==1">
            <li v-for="item in bzNews" :key="item.id" class="li li-culture">
              <div class="img" v-if="item.imgUrl != ''" :style="{backgroundImage:'url(' + apiUrl + item.imgUrl + ')'}"></div>
              <div v-else :style="{backgroundImage:'url(/imgs/rxlogo.jpg)'}"></div>
              <div class="text">
                <router-link :to="{'name':'article',query:{id:'426176045379653',aid:item.id}}">{{truncate(item.title,20)}}</router-link>
                <p>{{truncate(item.headTitle,100)}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="section2">
      <div class="wid">
        <div class="tabs-title">
          <ul class="tabs">
            <li class="li" :class="tab==1?'active':''" @click="tab=1" v-on:click="clickTab('cemetery')">
              <span class="a">墓园</span>
            </li>
            <li class="li" :class="tab==2?'active':''" @click="tab=2" v-on:click="clickTab('funeral')">
              <span class="a">殡仪馆</span>
            </li>
          </ul>
        </div>
        <div class="img_ls" v-show="tab==1">
          <swiper ref="swiper" :options="swiperOptions_ls">
            <swiper-slide
              class="swiper-slide_ls" v-for="(item, index) in cemetery" :key="'swiper' + index">
              <div style="display:flex;flex-direction:column;">
                <router-link :to="{'name': 'CemeteryDetail', query: { id: item.id, tenantId: item.tenantId } }">
                  <img class="swiper-slide__img" :src="apiUrl + item.homeImage" alt />
                  <span>{{item.name}}</span>
                </router-link>
              </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
        <div class="img_ls" v-show="tab==2">
          <swiper ref="swiper" :options="swiperOptions_ls">
            <swiper-slide class="swiper-slide_ls" v-for="(item, index) in funeral" :key="'swiper' + index">
              <div style="display:flex;flex-direction:column;">
                <router-link :to="{'name': 'FuneralDetail', query: { id: item.id, tenantId: item.tenantId } }">
                  <img class="swiper-slide__img" :src="apiUrl + item.homeImage" alt />
                  <span>{{item.name}}</span>
                </router-link>
              </div>
            </swiper-slide>
            <!-- Optional controls -->
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import axios from "axios";
import utils from "@/utils/uitl.js";
import formatDate from '@/utils/uitl.js';

// import Header from "./Header.vue";
// import Footer from "./Footer.vue";

export default {
  name: "Home",
  components: {
    // Header,
    // Footer,
  },
  data() {
    return {
      num: 1,
      tab: 1,
      number: 0,
      swiperOptions: {
        autoplay: 1000,
        loop: true,
        spaceBetween: 0,
        slidesPerView: "auto",
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      imgList: [
        "imgs/b1.jpg",
        "imgs/b2.jpg",
        "imgs/b3.jpg",
      ],
      cemetery: [],
      funeral: [],
      hyNews: [],
      zcNews: [],
      bzNews: [],
      apiUrl: '',
      tourl: 'cemetery',
      newUrl: 'article/list?id=426173197115461',
      swiperOptions_ls: {
        autoplay: 1000,
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        loopedSlides: 3,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  mounted() {
    this.newsQuery(426173197115461,3);
    this.newsQuery(426175958732869,4);
    this.newsQuery(426176045379653,1);
    this.getTenantList(1);
    this.getTenantList(2);
    this.apiUrl = axios.defaults.baseURL
  },

  methods: {
    //新闻中心
    newsQuery(nId,pageSize) {
      axios({
        url: "api/TombNotice/wxpage",
        method: "get",
        headers: { Authorization: "Bearer Fhc123456." },
        params: { NoticeTypeId: nId, PageSize: pageSize },
      }).then((res) => {
        if (res && res.data.success) {
          let data = res.data.data;
          let rows = data.rows;
          let arr = [];
          if(rows.length > 0){
            for (let i = 0; i < rows.length; i++) {
              const ele = rows[i];
              let id = ele.id;
              let title = ele.nt_Title;
              let imgUrl = ele.headImagerUrl == "" || ele.headImagerUrl == null ? "" : ele.headImagerUrl;
              let headTitle = ele.nt_Head == null ? "" : ele.nt_Head;
              let publicTime = formatDate(ele.publicTime,"YYYY-MM-DD");
              arr.push({
                "id":id,
                "title":title,
                "imgUrl":imgUrl,
                "headTitle":headTitle,
                "publicTime":publicTime
              });
            }

          }
          if (nId == "426173197115461") {
            this.hyNews = arr;
          } else if (nId == "426175958732869") {
            this.zcNews = arr;
          } else if (nId == "426176045379653") {
            this.bzNews = arr;
          }
        }
      });
    }, //changeQuery
    truncate(str,v){
      if(str.length > 0 && str.length > v){
        return str.substring(0,v) + "...";
      }else{
        return str;
      }
    },
    //墓园、殡仪馆
    getTenantList(type) {
      axios({
        url: "api/SysTenant_Ext/list",
        method: "get",
        headers: { Authorization: "Bearer Fhc123456." },
        params: { tenantType: type },
      }).then((res) => {
        if (res && res.data.success) {
          let data = res.data.data;
          if (type == 1) {
            this.cemetery = data;
          } else if (type == 2) {
            this.funeral = data;
          }
        }
      });
    },
    gotoUrl(url,params){
      if(!params || params.length == 0){
        this.$router.push({ path: '/' + url });
      }
    },
    clickTab(e){
      let tourl = e;
      this.tourl = tourl;
      this.newUrl = tourl;
    },
  },
};
</script>

<style>
.swiper-container {
  width: 100%;
  height: 442px !important;
  overflow: hidden;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */
  overflow: hidden;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}
.swiper-slide>div>a>img {
  border: 1px solid #ededed;
  background-image: url(/public/imgs/org_bg.png);
}
.swiper-slide>div>a>span {
  display: block;
}
.swiper-slide img {
  /*width: 100%;*/
  height: 445px;
}
.swiper-slide_ls {
/*  width: 300px !important;
  height: 350px !important;
  */
}
.swiper-slide_ls .swiper-slide__img {
  width: auto;
  height: 300px;
}
.swiper-slide-prev,
.swiper-slide-next {
  filter: brightness(0.4);
}
.swiper-slide_ls.swiper-slide-prev,
.swiper-slide_ls.swiper-slide-next {
  filter: none;
}
.index .swiper-container .swiper-button-prev {
  left: 0;
  background-image: url(data:image/png;base64,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);
  background-size: 100%;
}
.index .swiper-container .swiper-button-next {
  right: 0;
  background-image: url(data:image/png;base64,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);
  background-size: 100%;
}
.index .img_ls .swiper-button-prev {
  left: 0;
  top: 55%;
  background-image: url(data:image/png;base64,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);
}
.index .img_ls .swiper-button-next {
  right: 0;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABwCAMAAAC+YwepAAACEFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACAgIEBAQGBgYKCgoMDAwODg4PDw8VFRUZGRkcHBweHh4iIiIjIyMqKiosLCwyMjI5OTk8PDw+Pj5BQUFERERHR0dKSkpMTExPT09YWFhdXV1gYGBiYmJqampra2tvb290dHR1dXV2dnaAgICAgICCgoKEhISGhoaHh4eIiIiNjY2RkZGTk5Ofn5+hoaGjo6OmpqaoqKiqqqqrq6uurq6vr6+vr6+xsbG3t7e5ubm+vr7BwcHExMTExMTGxsbHx8fIyMjKysrR0dHT09PU1NTV1dXZ2dnZ2dna2trc3Nzc3Nzd3d3e3t7h4eHi4uLi4uLl5eXl5eXm5ubp6enq6urr6+vs7Ozt7e3u7u7u7u7v7+/v7+/w8PDx8fH09PT09PT19fX19fX29vb29vb39/f4+Pj5+fn5+fn7+/v7+/v8/Pz8/Pz9/f39/f3+/v7+/v7///+16g5iAAAArnRSTlMAAgMGBwoMDg8QEhYXHR4iJCUmJygpKis2OTo7QUJFRkdLTE1PUlVZW1xdX2BjZGdoaWpub3Bydnd4eX1+f4CAgYGCg4OEhYaHiImJi4yOkJGRkpOUlZaXmpydnqGio6WmpqqrrKytrq6xs7O6u7y9v8DAwsLDxMfJzM7P0NHR0tTZ2trb3t/f4OHh4uTl5ufo6evs7e3v7/Dw8fHz9PX19vb3+Pj5+vv8/P39/v43i+tNAAADG0lEQVRo3s3a91cTQRAH8AQiCkGRoEiQJjbANEAQvDCQBEGiKIgFFHvvvWDDLooNsIANO4qa+xeF7PqePs0W/ebp/Hr3Pskle7O7M2ux6IQ1Jd1ZWOwuq6gyjEXlXtf8OdlTJ1r+MGyOAq9Bv4nF7lnTbLpaaq7HT4IwFmTb1bUkp48UonzmBCUurchPimHMnSzlHB7SilIxl+kj3RBxdhcREEzM8xMSdFQSAcGEfCIkmOwhKJhRTVAwq4agYA4RErTOJihonUdY8C+/3y9gDmHBLMKCGTVYMLmaoGCCh7BgPmFBB2HBxEowmEdY0O4Hgy7CgjMIDPrAYAaBQcE70rBpc6M2mBb7+uonpvm8Qxcsin29xxyLV216YFLsMRj4PA6aj5drgU7B9cEoaN5t0AFFY2YvA80rAXUwVXjDGS52qYO5whvqLnPxsDIoSdQN97i4WxG0yfJM8xADRzvVQHmmXvOWie/WKoEF8ps2jjLx2QoV0Kvwsd8HT99SOWg1VH6Z41y8HpSCKUr/XW03Fy9KwXS14VV/i4snZaBT8Q0ID3BxvwQsVH3rW4cZ+GWLGCxRTkwdI0z80C4ENVZI2yJMfNEiAss00vtB/jMOLBOAFTozUBcXe+tjg1U6YOAaF0/FBg0dkBofMHAIBvYxcBD0yHVX+SOfAP0pp7l3O4QZNvu490g0bNzqXieb9c3Xq0QDu1jZa3vDvE8bMMkh/JA/8C5M+gre5N4RTIKls9y7gJkC6AD3ekKYSWrrV55nwphpdN175g23Yib65qfM+7gesxRZcod5kR2YxVLtJZ0FnXw5R8e4dw6z4KSd3LsRVAXFS+J2Pnn2N2EW7dTPvJctoG3FSuaNKG+mJBsfaopO7pHtsK0ZnR8HD+E2jxQ6er93D3J7+59swOElAksmGoSXWfCFIHipCl9Mg5f78AVJfMkUXtTFl53xhXF86R7fXMC3P+ANGnwLKQ5NLnwbDt8oxLcy8c3WOLSD8Q3raIugFAyOjSBs01/7WMKUf3FwIg5HO+SHT6ZrHz758XhMiYcdj1nIjsdM+vmWb8wouRsEvLfXAAAAAElFTkSuQmCC);
  background-position: 100%;
  top: 55%;
}
.swiper-button-next,
.swiper-button-prev {
  width: 40px;
  height: 45px;
  background-repeat: no-repeat;
  background-size: contain;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.swiper-button-next:after,
.swiper-container-rtl .swiper-button-prev:after,
.swiper-button-prev:after,
.swiper-container-rtl .swiper-button-next:after {
  content: "" !important;
}
.index .quick_link,
.index .quick_link .img {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
.swiper-button-prev,
.swiper-button-next {
  margin-top: calc(-1 * var(--swiper-navigation-size) / 1) !important;
}
.index .quick_link .img {
  -webkit-flex: 1 1;
  -ms-flex: 1 1;
  flex: 1 1;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  -webkit-align-items: center;
  -ms-flex-pack: center;
  align-items: center;
  margin: 20px 0 50px;
  padding: 0 10px 0 0;
  height: 140px;
  width: 260px;
  font-size: 36px;
  color: #fff;
  border-radius: 5px;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -webkit-text-stroke: 1px #fff;
  cursor: pointer;
  transition: 0.3s;
  position:relative;
}
.index .quick_link .img span {
  color:#fff;
  display:block;
}
.index .quick_link .img:hover {
  -webkit-transform: translateY(-2px);
  transform: translateY(-2px);
  box-shadow: 1px 2px 10px rgba(0, 0, 0, 0.43137254901960786);
}
.index .quick_link .img1 {
  background-image: url(/public/imgs/img_01.png);
  text-shadow: 0 0 4px #b88906;
}
.index .quick_link .img2 {
  margin-left: 30px;
  margin-right: 30px;
  background-image: url(/public/imgs/img_02.png);
  text-shadow: 0 0 4px #03aaa7;
}
.index .quick_link .img3 {
  margin-right: 30px;
  background-image: url(/public/imgs/img_03.png);
  text-shadow: 0 0 4px #e66a28;
}
.index .quick_link .img4 {
  background-image: url(/public/imgs/img_04.png);
  text-shadow: 0 0 4px #e66a28;
}
.index .quick_link .img a {
  position:absolute;
  width:100%;
  height:100%;
}
.index .section1 {
  display: -webkit-flex;
  display: flex;
}
.wid.wid-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.index .section1 .news {
  -webkit-flex: 1 1;
  flex: 1 1;
  margin: 0 0 30px;
}
.more {
  margin: 0 auto;
  font-size: 0.8rem;
  float: right;
  line-height: 2.2;
}
.bigTitle {
  text-align: center;
  font-size: 1.6rem;
  padding: 22px 0;
}
.index .section1 .news .newsUl {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.index .section1 .news .newsUl .li {
  cursor: pointer;
  transition: 0.3s;
  position:relative;
  width: 31.5%;
  box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3);
  border-radius: 10px;
}
.index .section1 .news .newsUl .li .num {
  padding: 0 10px;
}
.index .section1 .news .newsUl .li .h1 {
  font-size: 1rem;
  padding: 10px 0;
}
.index .section1 .news .newsUl .li .num .p {
  padding: 10px 0 20px 0;
  line-height: 1.6;
}
.index .section1 .news .newsUl .li .img {
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.index .section1 .news .newsUl .li a {
  position:absolute;
  width:100%;
  height:100%;
  top:0; left:0;
}
.widbg {
  width: 100%;
  background-color: #f6f6f6;
  padding: 25px 0;
}
.wid_flex {
  width: 48%;
}
.wid_flex .title {
  font-size: 1.6rem;
  border-bottom: 1px solid #d8d8d8;
}
.wid_flex .ls { padding: 12px 0; }
.wid_flex .ls .li {
  line-height: 35px;
}
.wid_flex .ls .li-culture {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: self-start;
}
.wid_flex .ls .li-culture .img {
  width: 204px;
  height: 150px;
  background-size: 100% 100%;
}
.li-culture .text {
  line-height: 1.4;
  margin-left:2%;
  width: 60%;
}
.li-culture .text p { line-height: 1.8; font-size: 0.9rem; }
.wid_flex .ls .li a { font-size: 1rem;}
.wid_flex .ls .li a span {
  float: right;
  display: inline;
}
.index .img_ls {
  padding: 0 0 10px;
}
.index .img_ls .swiper-container {
  height: 200px;
}
.tabs-title {
  text-align: center;
  margin-top: 24px;
}
.tabs-title .tabs { display: flex; flex-direction: row; justify-content: center; align-items: center;}
.tabs-title .tabs li { padding: 24px 20px; cursor: pointer;}
.tabs-title .tabs li.active { background:#006438; padding: 2px 32px; color:#fff; text-align: center; border-radius: 20px; }
.tabs-title .tabs li span { font-size: 1.8rem; }
</style>